<template>
    <div class="home">
        <h1>Course Info</h1>
        <table class="lined-table">
            <tr>
                <td><b>Lecture Section A</b></td>
                <td>MW 12:00-12:50<br/>MZ 126</td>
            </tr>
            <tr>
                <td><b>Lecture Section B</b></td>
                <td>MW 1:00-1:50 <br/>MZ 126</td>
            </tr>
            <tr>
                <td><b>Lecture Section C</b></td>
                <td>MW 2:00-2:50<br/>BE 243</td>
            </tr>
            <tr>
                <td><b>Recitation (Lab) Section R01</b></td>
                <td>F 12:00-12:50 <br/>MZ 026</td>
            </tr>
            <tr>
                <td><b>Recitation (Lab) Section R02</b></td>
                <td>F 1:00-1:50 <br/>MZ 026</td>
            </tr>
            <tr>
                <td><b>Recitation (Lab) Section R03</b></td>
                <td>F 2:00-2:50 <br/>MZ 026</td>
            </tr>
            <tr>
                <td><b>Recitation (Lab) Section R04</b></td>
                <td>F 11:00-11:50 <br/>MZ 026</td>
            </tr>
        </table>
        <p/>
        <table class="unlined-table">
            <tr>
                <td><b>Textbook:</b></td>
                <td>
                  We are using zyBooks this semester.  To gain access to the book:<br/>
                  <ol>
                    <li>Sign in or create an account at <a href="https://learn.zybooks.com" target="_blank">learn.zybooks.com</a></li>
                    <li>Enter zyBook code: MINESCSCI262Spring2022</li>
                    <li>Subscribe</li>
                  </ol>
                  Cost: $77
                </td>
            </tr>
            <tr>
                <td><b>Links:</b> </td>
                <td><a href="https://elearning.mines.edu/login/saml" target="_blank">Canvas</a></td>
            </tr>
            <tr>
                <td></td>
                <td><a href="https://piazza.com/mines/spring2022/csci262" target="_blank">Piazza</a></td>
            </tr>
        </table>
        <p/>
        <h2>Office Hours</h2>
        <!--<p><b>TBD</b></p>-->


    <!--<p>Office hours this semester will be held in the CTLM 246 peer mentoring space, except as noted below.</p>-->

    <table class="lined-table">
    <tr>
      <th>Day</th>
      <th>When/Who</th>
      <th>Where</th>
    </tr>

    <tr>
      <td><b>Mondays</b></td>
      <td>3 - 5pm (Chai, Zac)</td>
      <td>CTLM 246</td>
    </tr>

    <tr>
      <td rowspan="4"><b>Tuesdays</b></td>
      <td>10 - 11am (Joey)</td>
      <td>CTLM 246F</td>
    </tr>
    <tr>
      <td>11am - noon (CPW, Lauren)</td>
      <td>CTLM 246</td>
    </tr>
    <tr>
      <td>noon - 2pm (CPW)</td>
      <td>CTLM 246</td>
    </tr>
    <tr>
      <td>3 - 4pm (Noah, Zac)</td>
      <td>Alamode lab</td>
    </tr>

    <tr>
      <td rowspan="2"><b>Wednesdays</b></td>
      <td>4 - 5pm (CPW, Gus)</td>
      <td>CTLM 246</td>
    </tr>
    <tr>
      <td>5 - 6pm (CPW, Jess)</td>
      <td>CTLM 246</td>
    </tr>

    <tr>
      <td rowspan="3"><b>Thursdays</b></td>
      <td>10 - 11am (Joey)</td>
      <td>CTLM 246F</td>
    </tr>
    <tr>
      <td>11am - noon (Cole, Lauren)</td>
      <td>CTLM 246</td>
    </tr>
    <tr>
      <td>5 - 6pm (Noah, Nat)</td>
      <td>CTLM 246</td>
    </tr>

    <tr>
      <td><b>Fridays</b></td>
      <td>4 - 5pm (Cole, Gus)</td>
      <td>CTLM 246</td>
    </tr>
    </table>

<p><b>CTLM 246</b> is the peer mentoring space outside CPW's office (in CTLM above the computer commons).</p>
<p><b>Alamode lab</b> is in the basement of CTLM.</p>

        <p/>
        <h2>Instructor Info</h2>

        <table class="unlined-table">
            <tr>
                <td style="vertical-align: middle;">
                    <img src="../assets/photos/cpw.jpg" width="120" alt="Christopher Painter-Wakefield" />
                </td>
                <td style="vertical-align: middle;">
                    <table>
                        <tr>
                            <td colspan="2">
                                <div><b>Sections A, B, R01, R02</b></div>
                                <div>Christopher Painter-Wakefield (he, him, his)</div>
                            </td>
                        </tr>
                        <tr>
                            <td>email: </td>
                            <td><a href="mailto:cpainter@mines.edu">cpainter@mines.edu</a></td>
                        </tr>
                    </table>
                </td>
            </tr>
        </table>
        <p/>
        <table class="unlined-table">
            <tr>
                <td style="vertical-align: middle;">
                    <img src="../assets/photos/joey.jpg" width="120" alt="Joey Lovato" />
                </td>
                <td style="vertical-align: middle;">
                    <table>
                        <tr>
                            <td colspan="2">
                                <div><b>Sections C, R03, R04</b></div>
                                <div>Joey Lovato <i>(he, him, his)</i></div>
                            </td>
                        </tr>
                        <tr>
                            <td>email: </td>
                            <td><a href="mailto:jlovato@mines.edu">jlovato@mines.edu</a></td>
                        </tr>
                    </table>
                </td>
            </tr>
        </table>
        <p/>

        <h2>TA Staff</h2>
        <!--<p><b>TBA</b></p>-->


        <div class="ta-list">
            <div class="ta-entry">
                <div class="ta-item"><img src="../assets/photos/gus.jpg" alt="Gus Alves" class="portrait"/></div>
                <div class="ta-item">Gus Alves</div>
            </div>

            <div class="ta-entry">
                <div class="ta-item"><img src="../assets/photos/nat.jpg" alt="Nat Crawford" class="portrait"/></div>
                <div class="ta-item">Nat Crawford</div>
            </div>

            <div class="ta-entry">
                <div class="ta-item"><img src="../assets/photos/jess.jpg" alt="Jess Engel" class="portrait"/></div>
                <div class="ta-item">Jess Engel</div>
            </div>

            <div class="ta-entry">
                <div class="ta-item"><img src="../assets/photos/isa.jpg" alt="Isa Fernandes" class="portrait"/></div>
                <div class="ta-item">Isa Fernandes</div>
            </div>

            <div class="ta-entry">
                <div class="ta-item"><img src="../assets/photos/noah.jpg" alt="Noah Fields" class="portrait"/></div>
                <div class="ta-item">Noah Fields</div>
            </div>

            <div class="ta-entry">
                <div class="ta-item"><img src="../assets/photos/cole.jpg" alt="Cole Howard" class="portrait"/></div>
                <div class="ta-item">Cole Howard</div>
            </div>

            <div class="ta-entry">
                <div class="ta-item"><img src="../assets/photos/lauren.jpg" alt="Lauren Sherburne" class="portrait"/></div>
                <div class="ta-item">Lauren Sherburne</div>
            </div>

            <div class="ta-entry">
                <div class="ta-item"><img src="../assets/photos/chai.jpg" alt="Chayada Somrit" class="portrait"/></div>
                <div class="ta-item">Chayada Somrit</div>
            </div>

            <div class="ta-entry">
                <div class="ta-item"><img src="../assets/photos/preston.jpg" alt="Preston Walraven" class="portrait"/></div>
                <div class="ta-item">Preston Walraven</div>
            </div>

            <div class="ta-entry">
                <div class="ta-item"><img src="../assets/photos/zac.jpg" alt="Zac Wilson" class="portrait"/></div>
                <div class="ta-item">Zac Wilson</div>
            </div>
        </div>
    </div>
</template>

<script>
export default
 {
    name: 'Home'
}
</script>
